import { Component, inject } from "@angular/core";
import {
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-confirm-division-delete-dialog",
  templateUrl: "./confirm-division-delete-dialog.component.html",
  styleUrls: ["./confirm-division-delete-dialog.component.css"],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class ConfirmDivisionDeleteDialogComponent {
  dialogRef =
    inject<MatDialogRef<ConfirmDivisionDeleteDialogComponent>>(MatDialogRef);

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
